import { Component } from 'react';

import { BrokenAnimation } from '../common_components';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <BrokenAnimation loadingMessage="Something went wrong but we're working on it" />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
